import React, { useState } from "react";
import { Layout, Button, Typography, Dropdown, Space } from "antd";
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, DatabaseOutlined, FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import { useApp } from "../../../context/AppContext";
import { exportDatabaseToExcel, exportDatabaseToJson } from "../../../utils/export-db";

const { Header } = Layout;
const { Title } = Typography;

const AppHeader = ({ collapsed, setCollapsed, onLogout }) => {

  const { user, message } = useApp();
  const [exporting, setExporting] = useState(false);

  const isAdmin = user?.role === 'admin';

  // ייצוא כל ה-DB — לאדמין בלבד, לצורך מיפוי והעברה לאתר החדש.
  const runExport = async (exporter, label) => {
    setExporting(true);
    const key = 'db-export';
    message.loading({ content: `${label}: קורא נתונים...`, key, duration: 0 });
    try {
      const { collections, failed } = await exporter((name) => {
        message.loading({ content: `${label}: קורא ${name}...`, key, duration: 0 });
      });
      const total = Object.values(collections).reduce((sum, rows) => sum + rows.length, 0);
      const counts = Object.entries(collections).map(([name, rows]) => `${name}: ${rows.length}`).join(', ');
      if (failed.length) {
        message.warning({ content: `${label} הושלם (${total} מסמכים — ${counts}). לא נקראו: ${failed.map(f => f.name).join(', ')}`, key, duration: 8 });
      } else {
        message.success({ content: `${label} הושלם: ${total} מסמכים (${counts})`, key, duration: 6 });
      }
    } catch (error) {
      console.error(error);
      message.error({ content: `${label} נכשל: ${error?.message || error}`, key, duration: 6 });
    } finally {
      setExporting(false);
    }
  };

  const exportItems = [
    {
      key: 'excel',
      icon: <FileExcelOutlined />,
      label: 'ייצוא כל ה-DB לאקסל (גיליון לכל קולקשן)',
      onClick: () => runExport(exportDatabaseToExcel, 'ייצוא לאקסל'),
    },
    {
      key: 'json',
      icon: <FileTextOutlined />,
      label: 'ייצוא כל ה-DB ל-JSON (לייבוא באתר החדש)',
      onClick: () => runExport(exportDatabaseToJson, 'ייצוא ל-JSON'),
    },
  ];

  return (
    <Header
      style={{
        padding: "0 16px",
        background: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        direction: "rtl"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Button
          type="text"
          icon={collapsed ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
        />
        <Title level={4} style={{ margin: 0 }}>
          אזור אישי - מכון משלימים
        </Title>
      </div>

      <Title level={5} style={{ margin: 0 }}>
        {`שלום, ${user?.firstName || 'משתמש'} ${user?.lastName || ''} ${user?.role === 'admin' ? '- חשבון מנהל' : ''}`}
      </Title>

      <Space>
        {isAdmin && (
          <Dropdown menu={{ items: exportItems }} trigger={['click']} disabled={exporting}>
            <Button icon={<DatabaseOutlined />} loading={exporting}>
              ייצוא DB
            </Button>
          </Dropdown>
        )}

        <Button
          type="primary"
          danger
          icon={<LogoutOutlined />}
          onClick={onLogout}
        >
          התנתק
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader;
